  document.addEventListener('DOMContentLoaded', function () {
    const popupBtn = document.querySelector('.personalise-popup_btn');
    const popupContainer = document.querySelector('.personalise__pop_ctn_container');
    const closeButtons = document.querySelectorAll('.personalise__popclose');
    const applyBtn = document.getElementById('personalise_initial_btn');
    const resetBtn = document.getElementById('personalise_reset_btn');
    const addtoCartBtn = document.querySelector('.m-add-to-cart');

    const input1 = document.getElementById('personalise_initial_input');
    const input2 = document.getElementById('personalise_initial_input2');

    const preview1 = document.getElementById('personalise__result');
    const preview2 = document.getElementById('personalise__result2');

    const outputInput1 = document.getElementById('personalise__customInitial');
    const outputInput2 = document.getElementById('personalise__customInitial2');

    if (popupBtn && popupContainer) {
      popupBtn.addEventListener('click', function () {
        popupContainer.style.display = 'block';
      });
    }

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        popupContainer.style.display = 'none';
      });
    });

    function updatePreview() {
      preview1.textContent = input1.value;
      preview2.textContent = input2.value;
    }

    input1.addEventListener('input', updatePreview);
    input2.addEventListener('input', updatePreview);

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        popupContainer.style.display = 'none';
        outputInput1.value = input1.value;
        outputInput2.value = input2.value;
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        input1.value = '';
        input2.value = '';
        preview1.textContent = '';
        preview2.textContent = '';
      });
    }

    addtoCartBtn.addEventListener('click', function (event) {
      setTimeout(() => {
        input1.value = '';
        input2.value = '';
        preview1.textContent = '';
        preview2.textContent = '';
      }, 10);
    });
  });



  // add product
   localStorage.setItem("embroideryApplyed", false);

  function checkEmbroideryStatus() {
    console.log(checkEmbroideryStatus,'checkEmbroideryStatus')
    const name = document
      .getElementById("personalise_initial_input")
      ?.value.trim();
    const line2 = document
      .getElementById("personalise_initial_input2")
      ?.value.trim();
    const addText = document.querySelector(".add-embroidery");
    const appliedText = document.querySelector(".applied-embroidery");
    const isEmpty = !name && !line2;

    if (addText && appliedText) {
      addText.style.display = isEmpty ? "block" : "none";
      appliedText.style.display = isEmpty ? "none" : "block";
      localStorage.setItem("embroideryApplyed", !isEmpty);
    }
    console.log(
      localStorage.getItem("embroideryApplyed"),
      "embroideryApplyed status check"
    );
  }

  // Initial embroidery check
  checkEmbroideryStatus();

  // Add to Cart Custom Button Click
  $("#customAddToCartButton").click(function (e) {
    e.preventDefault();
    console.log("Add to Cart clicked");

    const embroideryApplied = localStorage.getItem("embroideryApplyed") === "true";
    console.log(embroideryApplied, "embroideryApplied++++");

    const quantityInput = document.querySelector(
      'form[action="/cart/add"] [name="quantity"]'
    );
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
    console.log(quantity, "quantity++++");

    const form = document.querySelector('form[action="/cart/add"]');
    console.log(form, "form++++");

    const formData = new FormData(form);
    const mainVariantId = formData.get("id");
    console.log(mainVariantId, "mainVariantId++++");

    if (!mainVariantId) {
      console.error("Main variant ID missing");
      return;
    }

    if (!embroideryApplied) {
      console.log("Adding main product without embroidery");
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: mainVariantId,
          quantity: quantity,
        },
        success: function () {
          localStorage.setItem("embroideryApplyed", false);
          if (window.MinimogTheme?.CartDrawer) {
            window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
            personalise_reset_btn();
            window.MinimogTheme.CartDrawer.open();
          } else {
            // Fallback
            const drawer = document.querySelector("m-cart-drawer");
            drawer?.onCartDrawerUpdate?.();
            drawer?.open?.();
          }
        },
        error: function (err) {
          console.error("Error adding main product:", err);
        },
      });
    } else {
      console.log("Adding main product with embroidery");
      const embroideryName = $("#personalise_initial_input").val().trim() || "";
      console.log(embroideryName, "embroideryName++++");
      const embroideryLine2 = $("#personalise_initial_input2").val().trim() || "";
      console.log(embroideryLine2, "embroideryLine2++++");
      const embroideryProductVariantId = "51570499354938";

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: mainVariantId,
          quantity: quantity,
          properties: {
            "Embroidery Name": embroideryName,
            "Embroidery Line 2": embroideryLine2,
          },
        },
        success: function () {
          console.log("Main product added with embroidery properties");
          localStorage.setItem("embroideryApplyed", false);

          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
              id: embroideryProductVariantId,
              quantity: quantity,
            },
            success: function () {
              console.log("Embroidery product added to cart");
              if (window.MinimogTheme?.CartDrawer) {
                window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
                personalise_reset_btn();
                window.MinimogTheme.CartDrawer.open();
              } else {
                // Fallback
                const drawer = document.querySelector("m-cart-drawer");
                drawer?.onCartDrawerUpdate?.();
                personalise_reset_btn();
                drawer?.open?.();
              }
            },
            error: function (err) {
              console.error("Error adding embroidery product:", err);
            },
          });
        },
        error: function (err) {
          console.error("Error adding main product with embroidery:", err);
        },
      });
    }
  });

  const embroideryVariantId = "51570499354938";
// _+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+
  function getEmbroideryLineItem(cartItems) {
    return cartItems.find((item) => item.variant_id == embroideryVariantId);
  }

  // ---------------------------------
function calculateEmbroideryQtyFromDOM() {
  let total = 0;
  $(".m-cart-item").each(function () {
    const $item = $(this);
    const variantId = $item.data("variant-id");  // or via a hidden input
    const hasEmbroidery = $item.find(".m-cart-item__property").length > 0 && variantId != embroideryVariantId;
    if (hasEmbroidery) {
      const qty = parseInt($item.find(".m-quantity__input").val(), 10) || 0;
      total += qty;
    }
  });
  return total;
}

// +++++++++++++++++++++++++++
  function updateEmbroideryQtyIfNeeded() {
    const expectedQty = calculateEmbroideryQtyFromDOM();
  
    $.getJSON("/cart.js", function (cart) {
      const embroideryItem = getEmbroideryLineItem(cart.items);
      const currentQty = embroideryItem ? embroideryItem.quantity : 0;
  
      if (expectedQty === currentQty) return;
  
      if (embroideryItem) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: { id: embroideryItem.key, quantity: expectedQty },
          success: refreshCart,
        });
      } else if (expectedQty > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: { id: embroideryVariantId, quantity: expectedQty },
          success: refreshCart,
        });
      }
    });
  }

// -/-/-/-/-/-/-/-/-/-/-/-/-/-/-/
  function refreshCart() {
    if (window.MinimogTheme?.CartDrawer) {
      window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
      window.MinimogTheme.CartDrawer.open();
    } else {
      // Fallback
      const drawer = document.querySelector("m-cart-drawer");
      drawer?.onCartDrawerUpdate?.();
      drawer?.open?.();
    }
  }

  let debounceTimeout;
  function debounceUpdate() {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(updateEmbroideryQtyIfNeeded, 900);
  }
// */*/*/*/*/*/*/*/*/*/*/*/*/*/*
$(document).on("click", ".m-cart-item .m-quantity__button", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (hasEmbroidery) debounceUpdate();
});

$(document).on("input", ".m-cart-item .m-quantity__input", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (hasEmbroidery) debounceUpdate();
});

$(document).on("click", ".m-cart-item__remove, .m-cart-item .remove-button", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (!hasEmbroidery) return;

  const qtyToRemove = parseInt($item.find(".m-quantity__input").val(), 10) || 0;
  // Adjust embroidery accordingly (similar logic)
  updateEmbroideryQtyIfNeeded();
});

// -*/-*/-*/-*/-*/-*/-*/-*/
let removeDebounceTimeout;

$(document).on("click", ".m-cart-item__remove, [id^=MinimogCartDrawer-Remove-]", function () {
  const $this = $(this); // preserve the context

  clearTimeout(removeDebounceTimeout);
  removeDebounceTimeout = setTimeout(function () {
    const $info = $this.closest(".m-cart-item__info, .m-cart-item");
    const hasEmbroidery = $info.find(".m-cart-item__property").length > 0;

    if (!hasEmbroidery) return;

    const qtyToRemove = parseInt($info.find("input[data-quantity-variant-id], .m-quantity__input").val(), 10) || 0;

    $.getJSON("/cart.js", function (cart) {
      const embroideryItem = getEmbroideryLineItem(cart.items);
      if (!embroideryItem) return;

      const newQty = Math.max(0, embroideryItem.quantity - qtyToRemove);

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: embroideryItem.key,
          quantity: newQty,
        },
        success: function () {
          refreshCart();
        },
      });
    });
  }, 1500);
});

// -*/+_)-*/+_)-*/+_)
function applyEmbroidery() {
  const nameInput = document.getElementById("personalise_initial_input");
  const line2Input = document.getElementById("personalise_initial_input2");
  console.log(nameInput,'nameInput');
  console.log(line2Input,'nameInput');

  document.getElementById("hiddenEmbroideryName").value =
    nameInput?.value || "";
  document.getElementById("hiddenEmbroideryLine2").value =
    line2Input?.value || "";
  document.getElementById("personalise__result").innerText =
    nameInput?.value || "";
  document.getElementById("personalise__result2").innerText =
    line2Input?.value || "";

  checkEmbroideryStatus();
}
// +-*+-*+-*+-*+-*+-*+-*+-*+-*+-*
function personalise_reset_btn() {
  [
    "personalise_initial_input",
    "personalise_initial_input2",
    "hiddenEmbroideryName",
    "hiddenEmbroideryLine2",
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.value = "";
  });

  ["personalise__result", "personalise__result2"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.innerText = "";
  });

  checkEmbroideryStatus();
}